export default __webpack_public_path__ + "static/media/Matter-Medium.5cb6bcdd.eot";